import {
  associatedCountryFlagForCountryCode,
  Country,
  getAllCountries,
} from '@getpopsure/public-models';
import { AutoSuggestInput } from '@popsure/dirty-swan';
import { Dispatch, SetStateAction, useState } from 'react';
import { useSafeTranslation } from 'shared/i18n';
import { filterOutCountries } from 'shared/util/filterOutCountries';

type CountrySelectStandaloneProps = {
  filterCountry?: Country[];
  locale?: Parameters<typeof getAllCountries>[0];
  country?: Country;
  setCountry: Dispatch<SetStateAction<Country | undefined>>;
};

interface Option {
  value: string;
  leftIcon?: string;
}

export const CountrySelectStandalone = ({
  country,
  setCountry,
  filterCountry,
  locale,
}: CountrySelectStandaloneProps) => {
  const { t } = useSafeTranslation();

  const [currentOption, setCurrentOption] = useState(country?.name ?? '');
  const [suggestions, setSuggestions] = useState<Option[]>([]);

  const countries =
    filterCountry && filterCountry.length > 0
      ? filterOutCountries(filterCountry, locale)
      : getAllCountries(locale);

  return (
    <AutoSuggestInput
      currentOption={currentOption}
      placeholder={t(
        'components.countrySelectStandalone.country.placeholder',
        'Country'
      )}
      suggestions={suggestions}
      onChange={(inputValue) => {
        setCurrentOption(inputValue);
        const selectedCountry = countries.find((c) => c.name === inputValue);
        setCountry(selectedCountry);
      }}
      handleSuggestionSelected={(option) => {
        setCurrentOption(option.value);
        const selectedCountry = countries.find((c) => c.name === option.value);
        setCountry(selectedCountry);
      }}
      handleSuggestionFetchRequest={(option) => {
        const filteredOptions = countries
          .filter((c) =>
            c.name.toLowerCase().startsWith(option.value.toLowerCase())
          )
          .map((c) => ({
            value: c.name,
            leftIcon: associatedCountryFlagForCountryCode(c.code),
          }));
        setSuggestions(filteredOptions);
      }}
      handleSuggestionClearRequest={() => setSuggestions([])}
    />
  );
};
